import { IFileValidatorProps, TValidFileExtensions } from "../types/forms";

const useFileTypeValidator = ({
    maxFileSize,
    allowedFileExtensions,
}: IFileValidatorProps) => {
    const validateFileType = (file: File): boolean => {
        if (file) {
            const fileExtension = file.name.split(".").pop();
            return allowedFileExtensions.includes(
                fileExtension?.toLowerCase() as TValidFileExtensions,
            );
        } else {
            return false;
        }
    };

    const validateFileSize = (file: File): boolean => {
        if (file) {
            return file.size <= maxFileSize;
        } else {
            return false;
        }
    };

    return {
        validateFileType,
        validateFileSize,
    };
};

export default useFileTypeValidator;
